var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLpp1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #c9c9c9;\n        stroke: #c9c9c9;\n        stroke-miterlimit: 10;\n        stroke-width: .2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "4.89 9.17 2.93 9.17 2.93 20.83 8.79 20.83 8.79 19.14 4.89 19.14 4.89 9.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m13.7,9.17h-3.85v11.66h1.96v-4.66h1.89c3.03,0,4.11-1.8,4.11-3.48s-1.08-3.52-4.11-3.52Zm0,5.3h-1.89v-3.6h1.89c1.45,0,2.12.58,2.12,1.81s-.69,1.78-2.12,1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m22.96,9.17h-3.85v11.66h1.96v-4.66h1.89c3.03,0,4.11-1.8,4.11-3.48s-1.08-3.52-4.11-3.52Zm0,5.3h-1.89v-3.6h1.89c1.45,0,2.12.58,2.12,1.81s-.69,1.78-2.12,1.78Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLpp1);
export default __webpack_public_path__ + "static/media/lpp-1.c4360c4cb8eba06f95eb095640e8e046.svg";
export { ForwardRef as ReactComponent };